/**
 * Безопасные обёртки для localStorage и sessionStorage
 * Решает проблему Safari Private Mode, где storage выбрасывает исключения
 */

export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string): boolean => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
  removeItem: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch {
      // Игнорируем ошибку в Safari Private Mode
    }
  },
  clear: (): void => {
    try {
      localStorage.clear();
    } catch {
      // Игнорируем ошибку в Safari Private Mode
    }
  },
};

export const safeSessionStorage = {
  getItem: (key: string): string | null => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string): boolean => {
    try {
      sessionStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
  removeItem: (key: string): void => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // Игнорируем ошибку в Safari Private Mode
    }
  },
  clear: (): void => {
    try {
      sessionStorage.clear();
    } catch {
      // Игнорируем ошибку в Safari Private Mode
    }
  },
};
